import type Hls from "hls.js";

declare const __BUILD__: string;

declare global {
  interface Window {
    __Hls?: typeof Hls;
  }
}

let loading: Promise<typeof Hls> | null = null;

/**
 * Догрузить бандл hls.js по требованию.
 *
 * Тегом `<script>`, а не `import()`: esbuild с `format: "iife"` вшивает
 * динамический импорт в основной бандл, и полтора мегабайта запасного пути
 * поехали бы каждому зрителю — да ещё и внутрь бинарника сервера через
 * rust-embed. Метка сборки в адресе обязательна: без неё посредник придержит
 * старую копию, и отлаживаться будет несуществующая ошибка.
 */
export function loadHlsBundle(): Promise<typeof Hls> {
  if (window.__Hls) return Promise.resolve(window.__Hls);
  if (loading !== null) return loading;

  loading = new Promise<typeof Hls>((resolve, reject) => {
    const script = document.createElement("script");
    script.src = `hls.js?v=${__BUILD__}`;
    script.addEventListener("load", () => {
      const loaded = window.__Hls;
      if (loaded) resolve(loaded);
      else reject(new Error("hls.js загрузился, но себя не объявил"));
    });
    script.addEventListener("error", () =>
      reject(new Error("не загрузить hls.js")),
    );
    document.head.appendChild(script);
  });
  return loading;
}
